// Card-only manifest for the WorkBuddy Company CRM Contact — this is a Contact, not tenant.company.
// Both portals reuse the tenant card verbatim, so `domains` replays the same object.
import { ActivityEntityName, Contact, DomainType } from '@jms/model';
import type { EntityManifestCard } from '@workbuddy/services/entities/entity.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

const card: EntityManifestCard<Contact> = {
  component: () => import('./entity.card.renderer/workbuddy.company.entity.card.renderer.component').then(module => module.WorkBuddyCompanyEntityCardRendererComponent),
  resolution: 'if-needed',
  isComplete: value => !!(value.mobile || value.phone || value.email || value.address?.street1 || value.address?.suburb),
  summarize: value => ({ title: value.name ?? 'Not set' }),
};

export const workBuddyCompanyManifest = registerManifest<Contact>({
  entity: ActivityEntityName.WorkBuddyCompany,
  slug: 'workbuddy-company',
  presentation: { card },
  domains: {
    [DomainType.ClientPortal]: { presentation: { card } },
    [DomainType.ContractorPortal]: { presentation: { card } },
  },
});
